import React from 'react';
import { StatusInfoError } from '../StatusInfo';
import { StatusInfoModifier } from '../StatusInfo/partials/StatusInfo';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export default function ErrorDisabledJavascript() {
  const { t } = useSonTranslation('ErrorDisabledJavascript');
  return (
    <noscript className="error-disabled-javascript">
      <StatusInfoError
        message={t('javascriptDeactivated')}
        modifier={[StatusInfoModifier.RED, StatusInfoModifier.CENTER]}
      />
    </noscript>
  );
}
